﻿﻿export interface IDonorInfoForCryo {
    donorId: number;
    alias: string;
    centerAlias: string;
    fullBloodType: string;
    hasCryoAtNkrLab: string;
    numberOfVials: number;
    donorName: string;
    dob: string;
    gender: string;
    donorHasTyping: boolean;
}
